import React from 'react'

function Splash() {
  return (
    <div className="splash">
      <span role="img" aria-label="Postal office emoji">
        {/* 🏤 */}
      </span>
    </div>
  )
}

export default Splash